// AppRouter.js (NEW FILE - create this)
import React from "react";
import { useLocation } from "react-router-dom";
import { MortgageGuideRoutes } from 'GenericMortgageGuides';
import { CookieSetting } from "cookiesetting-component";
import Footer from './components/FooterNew/index';
import App from './App';

function AppRouter() {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  
  // Check if it's a guides path (mortgage guides)
  const isGuidesPath = currentPath.startsWith('/guides');
  
  return (
    <React.Fragment>
      {isGuidesPath ? (
        <MortgageGuideRoutes
          homePath="/"
          showHeader={true}
          showFooter={true}
          FooterComponent={Footer}
        />
      ) : (
        <App />
      )}
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </React.Fragment>
  );
}

export default AppRouter;
